import { AppSubjectEnum } from '../modules/authz/enums/app-subject.enum';

import { ApiResponse } from './api-response';

/**
 * Represents the structured response for a deletion API call.
 */
export class ApiRecordDeleteResponse<T> extends ApiResponse<T> {
	/**
	 * An array of table names that are blocking the deletion.
	 */
	dependencies?: AppSubjectEnum[];
}
